export const fileTypes = {

    qlp: "qlp",
    ddpcr: "ddpcr",
    validDdpcrFileTypes: ["ddpcr", "ddpcrs", "ddpcrone", "ddpcrsone"],
    validQlpFileTypes: ["qlp"]
};

export const ENDPOINTS = {

    qlp: fileTypes["qlp"],
    ddpcr: fileTypes["ddpcr"],
    validDdpcrFileTypes: fileTypes["validDdpcrFileTypes"],
    validQlpFileTypes: fileTypes["validQlpFileTypes"]
}
